//* Libraries Imports
import { Component } from "react";

//* Components Imports
import Modal from "react-bootstrap/Modal";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Spinner,
  InputGroup,
  FormControl,
  Button,
  ListGroup,
  Pagination,
} from "react-bootstrap";

import ExamesAnterioresModal from "./ExamesAnterioresModal";

//* Variables Imports
import { URL } from "../../../variables";
import CondicoesEspeciaisBox from "./CondicoesEspeciaisBox";

class AvaliacaoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalAvaliacao: false,
      avaliacao_status: "",
      avaliacao_observacoes: "",
      avaliacao_faculdade_id: "",
      avaliacao_processo_selected: "",
      avaliacao_processo_id: "",
      faculdades: [],
      processos: [],
      loading_faculdades: false,
      loading_processos: false,
      saving_avaliacao: false,
      alert: null,
      inscricao: null,
      loading_search: false,
      loading_screen: false,
      redirect: false,
      faculdades_page: 1,
      faculdades_last_page: 1,
      faculdades_search: "",
      processos_page: 1,
      processos_last_page: 1,
      processos_search: "",
      processo_selected: "",
      seletivos_selecionados: [],
      seletivos_detalhes: [],
      showExamesModal: false,
      condicao_status:''
    };
    this.faculdadesSearchTimeout = null;
    this.processosSearchTimeout = null;
  }

  componentDidMount() {
    // this.loadFaculdades();
  }

  openModalAvaliacao = (inscricao) => {
    const status =
      inscricao.statusAvaliacao || inscricao.status_avaliacao || "";
    const observacoes =
      inscricao.observacoesAvaliacao || inscricao.observacoes_avaliacao || "";
    let faculdadeId =
      (inscricao.faculdade?.id ?? inscricao.faculdade_id ?? "") || "";
    let processoId =
      (inscricao.processo?.id ?? inscricao.processo_id ?? "") || "";
    const processoSelectedId = (inscricao.processoSelectedId ?? {}) || {};
    const fallbackFaculdadeId = faculdadeId || processoSelectedId?.faculdade_id || 1;
    const seletivosList = inscricao.seletivosList || inscricao.seletivos_list || [];
    const seletivosIds = inscricao.seletivosListIds || seletivosList.map((item) => item.id);

    const processoName =
      inscricao.processo?.name ?? inscricao.processo_name ?? "";

    if (faculdadeId == "" && processoId == "" && processoSelectedId) {
      console.log("entrou", this.state.faculdades);
      let faculdade_selected = this.state.faculdades?.filter(
        (item) => item.id == processoSelectedId?.faculdade_id,
      )[0];
      if (faculdade_selected) {
        console.log("achou", faculdade_selected);
        faculdadeId = faculdade_selected.id;
        processoId = processoSelectedId.id;

        this.setState(
          {
            avaliacao_faculdade_id: faculdade_selected.id,
            avaliacao_processo_id: processoSelectedId?.id ?? "",
          },
          () => {
            const target = Math.max(
              1,
              Math.min(
                this.state.processos_page,
                this.state.processos_last_page,
              ),
            );
            if (faculdadeId) {
              this.loadProcessos(
                faculdadeId,
                true,
                target,
                '',
              );
            }
          },
        );
      }
    }
    console.log(inscricao)
    console.log(inscricao.condicoesEspeciais && inscricao.statusCondicoesEspeciais ? inscricao.statusCondicoesEspeciais: '')
    this.setState(
      {
        showModalAvaliacao: true,
        inscricao: inscricao,
        avaliacao_status: status,
        condicao_status:inscricao.condicoesEspeciais && inscricao.statusCondicoesEspeciais ? inscricao.statusCondicoesEspeciais: '',
        avaliacao_observacoes: observacoes,
        avaliacao_faculdade_id: fallbackFaculdadeId ? String(fallbackFaculdadeId) : "",
        avaliacao_processo_id: processoId ? String(processoId) : "",
        avaliacao_processo_selected: processoSelectedId,
        seletivos_selecionados: (seletivosIds || []).map((id) => String(id)),
        seletivos_detalhes: seletivosList || [],
        // processos_search: processoName || "",
      },
      () => {
        console.log(this.state.avaliacao_processo_selected);
        const facId = fallbackFaculdadeId;
        if (facId) {
          this.loadProcessos(facId, true, 1, "");
        }
      },
    );
  };

  closeModalAvaliacao = () => {
    this.setState({
      showModalAvaliacao: false,
      avaliacao_status: "",
      avaliacao_observacoes: "",
      avaliacao_faculdade_id: "",
      avaliacao_processo_id: "",
      seletivos_selecionados: [],
      seletivos_detalhes: [],
      inscricao: null,
    });
  };

  onChangeStatus = (value) => {
    this.setState((prev) => ({
      avaliacao_status: value,
      avaliacao_observacoes:
        (prev.avaliacao_status === "deferida" && value === "indeferida") ||
        (prev.avaliacao_status === "indeferida" && value === "deferida")
          ? ""
          : prev.avaliacao_observacoes,
    }));
  };

  loadFaculdades = (busca = true, page = 1, search = "") => {
    if (busca === true) {
      if (this.state.loading_search === false) {
        this.setState({ loading_search: true });
      }
    } else if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    this.setState({ loading_faculdades: true });
    fetch(`${URL}api/faculdade/get_faculdades?page=${page}&search=${search}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.props.token}`,
      },
    })
      .then(async (responseLog) => {
        try {
          const resp = await responseLog.json();
          if (resp?.message === "Unauthenticated.") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.props.logout && this.props.logout();
            return;
          }
          if (
            resp?.errors != null ||
            resp?.error != null ||
            resp?.result === false
          ) {
            const errors = Object.values(resp.errors || {});
            let erro = "";
            for (let i = 0; i < errors.length; i++) {
              erro += i !== errors.length - 1 ? errors[i] + "\n" : errors[i];
            }
            this.showAlert("error", "Erro", erro);
            this.setState({ redirect: true });
          } else {
            const faculdades =
              resp?.faculdades || resp?.data || resp?.items || [];
            const meta = resp?.meta || resp?.pagination || {};
            const currentPage =
              meta?.current_page ?? resp?.current_page ?? page ?? 1;
            const lastPage = meta?.last_page ?? resp?.last_page ?? 1;

            this.setState({
              faculdades,
              faculdades_page: Number(currentPage) || 1,
              faculdades_last_page: Number(lastPage) || 1,
              loading_search: false,
              loading_screen: false,
            });
          }
        } catch (err) {
          this.showAlert("error", "Erro", "Erro ao carregar faculdades.");
          console.log(err);
          this.setState({ redirect: true });
        }
      })
      .catch((err) => {
        this.showAlert(
          "error",
          "Erro",
          "Erro de conexão ao carregar faculdades.",
        );
        console.log(err);
        this.setState({ redirect: true });
      })
      .finally(() => {
        this.setState({ loading_faculdades: false });
      });
  };

  loadProcessos = (faculdadeId, busca = true, page = 1, search = "") => {
    if (busca === true) {
      if (this.state.loading_search === false) {
        this.setState({ loading_search: true });
      }
    } else if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    this.setState({ loading_processos: true });
    const cpfCandidato =
      this.state.inscricao?.cpf || this.state.inscricao?.cpf_candidato || "";
    const cpfParam = cpfCandidato
      ? `&cpf_candidato=${encodeURIComponent(cpfCandidato)}`
      : "";
    const nivelEnsino =
      this.state.inscricao?.nivelEnsino || this.state.inscricao?.nivel_ensino || "";
    const nivelParam = nivelEnsino
      ? `&nivel_ensino=${encodeURIComponent(nivelEnsino)}`
      : "";
    fetch(
      `${URL}api/faculdade/get_processos/${faculdadeId}?page=${page}&search=${encodeURIComponent(search)}${cpfParam}${nivelParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.props.token}`,
        },
      },
    )
      .then(async (responseLog) => {
        try {
          const resp = await responseLog.json();
          if (resp?.message === "Unauthenticated.") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.props.logout && this.props.logout();
            return;
          }
          if (
            resp?.errors != null ||
            resp?.error != null ||
            resp?.result === false
          ) {
            const errors = Object.values(resp.errors || {});
            let erro = "";
            for (let i = 0; i < errors.length; i++) {
              erro += i !== errors.length - 1 ? errors[i] + "\n" : errors[i];
            }
            this.showAlert("error", "Erro", erro);
            this.setState({ redirect: true });
          } else {
            const processos =
              resp?.processos || resp?.data || resp?.items || [];
            const meta = resp?.meta || resp?.pagination || {};
            const currentPage =
              meta?.current_page ?? resp?.current_page ?? page ?? 1;
            const lastPage = meta?.last_page ?? resp?.last_page ?? 1;
            const processosRealizados = (resp?.processos_realizados || []).map(
              (id) => String(id),
            );
            const codeEsperado =
              String(nivelEnsino).toLowerCase() === "medio"
                ? "M"
                : String(nivelEnsino).toLowerCase() === "fundamental"
                  ? "F"
                  : "";
            const seletivosSelecionados = this.state.seletivos_selecionados.filter(
              (id) => {
                const detalhe = this.state.seletivos_detalhes.find(
                  (item) => String(item.id) === String(id),
                );

                return (
                  !processosRealizados.includes(String(id)) &&
                  (
                    !codeEsperado ||
                    !detalhe?.code ||
                    String(detalhe.code).toUpperCase() === codeEsperado
                  )
                );
              },
            );
            this.setState({
              processos,
              seletivos_detalhes: this.mergeSeletivosDetalhes(processos),
              seletivos_selecionados: seletivosSelecionados,
              avaliacao_processo_id: seletivosSelecionados[0] || "",
              processos_page: Number(currentPage) || 1,
              processos_last_page: Number(lastPage) || 1,
              loading_search: false,
              loading_screen: false,
            });
          }
        } catch (err) {
          this.showAlert(
            "error",
            "Erro",
            "Erro ao carregar processos seletivos.",
          );
          console.log(err);
          this.setState({ redirect: true });
        }
      })
      .catch((err) => {
        this.showAlert(
          "error",
          "Erro",
          "Erro de conexão ao carregar processos seletivos.",
        );
        console.log(err);
        this.setState({ redirect: true });
      })
      .finally(() => {
        this.setState({ loading_processos: false });
      });
  };

  handleSaveAvaliacao = () => {
    const {
      inscricao,
      avaliacao_status,
      avaliacao_faculdade_id,
      avaliacao_processo_id,
      avaliacao_observacoes
    } = this.state;
    if (!inscricao) return;

    if(inscricao.condicoesEspeciais && !this.state.condicao_status) return;

    if (
      avaliacao_status === "deferida" &&
      this.state.seletivos_selecionados.length === 0
    ) {
      this.showAlert(
        "error",
        "Erro",
        "Selecione ao menos um agendamento para deferir a inscrição.",
      );
      return;
    }

    // if (
    //   avaliacao_status === "deferida" &&
    //   (!avaliacao_faculdade_id || !avaliacao_processo_id)
    // ) {
    //   this.showAlert(
    //     "error",
    //     "Erro",
    //     "Não é permitido enviar com status deferido sem faculdade ou processo selecionados.",
    //   );
    //   return;
    // }

    if (avaliacao_status === "deferida") {
      const jaRealizou = String(inscricao.jaRealizouExame || "").toLowerCase();
      const temExames =
        inscricao.examesAnteriores && inscricao.examesAnteriores.length > 0;

      const jaTemAproveitamento =
        inscricao.aproveitamentoNotasExternas ||
        inscricao.aproveitamento_notas_externas;

      // If candidate has previous exams, open the selection modal
      if (
        (jaRealizou === "sim" || jaRealizou === "true") &&
        temExames &&
        !jaTemAproveitamento
      ) {
        this.setState({ showExamesModal: true });
        return;
      }
    }
    else if(!avaliacao_status || (avaliacao_status=='indeferida' && avaliacao_observacoes.length<10))return;

    this.submitAvaliacao();
  };

  submitAvaliacao = (aproveitamentoData = null) => {
    const {
      inscricao,
      avaliacao_status,
      avaliacao_observacoes,
      avaliacao_faculdade_id,
      avaliacao_processo_id,
      seletivos_selecionados,
    } = this.state;

    this.setState({
      saving_avaliacao: true,
    });

    const data = {
      status_avaliacao: avaliacao_status,
      observacoes_avaliacao: avaliacao_observacoes,
      status_condicao_especial:this.state.condicao_status ?this.state.condicao_status: 'indeferida'
    };
    console.log(data)
    if (avaliacao_status === "deferida") {
      if (avaliacao_faculdade_id) {
        data.faculdade_id = parseInt(avaliacao_faculdade_id, 10);
      }
      if (seletivos_selecionados.length > 0) {
        data.seletivos_list = seletivos_selecionados.map((id) => parseInt(id, 10));
        data.processo_id = data.seletivos_list[0];
      } else if (avaliacao_processo_id) {
        data.processo_id = parseInt(avaliacao_processo_id, 10);
      }
    }

    if (aproveitamentoData) {
      data.aproveitamento_notas_externas = aproveitamentoData;
    }

    fetch(`${URL}api/inscricoes/${inscricao.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.props.token}`,
      },
      body: JSON.stringify(data),
    })
      .then(async (responseLog) => {
        let resp = null;
        try {
          resp = await responseLog.json();
        } catch (_) {}
        try {
          if (resp?.message === "Unauthenticated.") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.props.logout && this.props.logout();
            return;
          }
          const isError =
            !responseLog.ok ||
            resp?.status === "error" ||
            resp?.exception != null ||
            resp?.errors != null ||
            resp?.error != null ||
            resp?.result === false;
          if (isError) {
            const errors = Object.values(resp?.errors || {});
            let erro = resp?.message || resp?.error?.message || "";
            if (errors.length) {
              erro = errors.join("\n");
            }
            if (!erro) erro = "Erro ao salvar avaliação.";
            this.showAlert("error", "Erro", erro);
            this.setState({ redirect: false });
          } else {
            this.showAlert(
              "success",
              "Sucesso",
              "Inscrição avaliada com sucesso!",
            );
            this.setState({ showExamesModal: false });
            this.closeModalAvaliacao();
            this.props.onSaveSuccess && this.props.onSaveSuccess();
          }
        } catch (err) {
          this.showAlert("error", "Erro", "Erro ao salvar avaliação.");
          console.log(err);
          this.setState({ redirect: false });
        }
      })
      .catch((err) => {
        this.showAlert("error", "Erro", "Erro de conexão ao salvar avaliação.");
        console.log(err);
        this.setState({ redirect: false });
      })
      .finally(() => {
        this.setState({ saving_avaliacao: false });
      });
  };

  showAlert = (type, title, message) => {
    this.setState({
      alert: (
        <SweetAlert
          type={type}
          title={title}
          onConfirm={() => {
            this.setState({ alert: null });
          }}
        >
          {message}
        </SweetAlert>
      ),
    });
  };

  handleFaculdadesSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ faculdades_search: value });
    if (this.faculdadesSearchTimeout)
      clearTimeout(this.faculdadesSearchTimeout);
    this.faculdadesSearchTimeout = setTimeout(() => {
      this.loadFaculdades(true, 1, value);
    }, 400);
  };

  handleProcessosSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ processos_search: value });
    if (this.processosSearchTimeout) clearTimeout(this.processosSearchTimeout);
    this.processosSearchTimeout = setTimeout(() => {
      const faculdadeId = this.state.avaliacao_faculdade_id;
      if (faculdadeId) {
        this.loadProcessos(faculdadeId, true, 1, value);
      }
    }, 400);
  };

  goToFaculdadesPage = (page) => {
    const target = Math.max(1, Math.min(page, this.state.faculdades_last_page));
    this.loadFaculdades(true, target, this.state.faculdades_search);
  };

  goToProcessosPage = (page) => {
    const target = Math.max(1, Math.min(page, this.state.processos_last_page));
    const faculdadeId = this.state.avaliacao_faculdade_id;
    if (faculdadeId) {
      this.loadProcessos(
        faculdadeId,
        true,
        target,
        this.state.processos_search,
      );
    }
  };

  selectFaculdade = (id) => {
    this.setState({
      avaliacao_faculdade_id: String(id),
      avaliacao_processo_id: "",
      seletivos_selecionados: [],
      processos: [],
      processos_page: 1,
      processos_last_page: 1,
      processos_search: "",
    });
    if (id) this.loadProcessos(id, true, 1, "");
  };

  selectProcesso = (id) => {
    this.setState({ avaliacao_processo_id: String(id) });
  };

  mergeSeletivosDetalhes = (processos) => {
    const map = {};
    [...this.state.seletivos_detalhes, ...(processos || [])].forEach((processo) => {
      if (processo && processo.id) {
        map[String(processo.id)] = processo;
      }
    });
    return Object.values(map);
  };

  toggleSeletivo = (processo) => {
    const id = String(processo.id);
    this.setState((prev) => {
      const selected = prev.seletivos_selecionados.includes(id)
        ? prev.seletivos_selecionados.filter((item) => item !== id)
        : [...prev.seletivos_selecionados, id];

      return {
        seletivos_selecionados: selected,
        seletivos_detalhes: this.mergeSeletivosDetalhes([processo]),
        avaliacao_processo_id: selected[0] || "",
      };
    });
  };

  formatProcessoDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  renderPagination = (current, last, onChange) => {
    if (!last || last <= 1) return null;
    const items = [];
    const start = Math.max(1, current - 2);
    const end = Math.min(last, current + 2);
    items.push(
      <Pagination.Prev
        key="prev"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
      />,
    );
    if (start > 1)
      items.push(
        <Pagination.Item key={1} onClick={() => onChange(1)}>
          {1}
        </Pagination.Item>,
      );
    if (start > 2)
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    for (let p = start; p <= end; p++) {
      items.push(
        <Pagination.Item
          key={p}
          active={p === current}
          onClick={() => onChange(p)}
        >
          {p}
        </Pagination.Item>,
      );
    }
    if (end < last - 1)
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    if (end < last)
      items.push(
        <Pagination.Item key={last} onClick={() => onChange(last)}>
          {last}
        </Pagination.Item>,
      );
    items.push(
      <Pagination.Next
        key="next"
        disabled={current >= last}
        onClick={() => onChange(current + 1)}
      />,
    );
    return (
      <Pagination size="sm" className="mt-2">
        {items}
      </Pagination>
    );
  };

  render() {
    const {
      showModalAvaliacao,
      avaliacao_status,
      avaliacao_observacoes,
      avaliacao_faculdade_id,
      avaliacao_processo_id,
      faculdades,
      processos,
      loading_faculdades,
      loading_processos,
      saving_avaliacao,
      faculdades_page,
      faculdades_last_page,
      faculdades_search,
      processos_page,
      processos_last_page,
      processos_search,
      seletivos_selecionados,
      seletivos_detalhes,
      showExamesModal,
    } = this.state;

    return (
      <>
        <Modal
          show={showModalAvaliacao}
          onHide={this.closeModalAvaliacao}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Avaliar inscrição</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <label style={{ color: "black", fontWeight: 600 }}>
                  Status  <b style={{color:'red'}}>*</b>
                </label>
                <select
                  className="form-control"
                  value={avaliacao_status}
                  onChange={(e) => this.onChangeStatus(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="deferida">Deferida</option>
                  <option value="indeferida">Indeferida</option>
                </select>
              </div>
              {this.state.inscricao?.condicoesEspeciais && <div className="col-md-6">
                <label style={{ color: "black", fontWeight: 600 }}>
                  Status Condição especial <b style={{color:'red'}}>*</b>
                </label>
                <select
                  className="form-control"
                  value={this.state.condicao_status}
                  onChange={(e) => this.setState({condicao_status:e.target.value})}
                >
                  <option value="">Selecione...</option>
                  <option value="deferida">Deferida</option>
                  <option value="indeferida">Indeferida</option>
                </select>
              </div>}
            </div>
        {this.state.inscricao?.id && <CondicoesEspeciaisBox inscricao={this.state.inscricao} />}

            {avaliacao_status === "deferida" && (
              <div className="row" style={{ marginTop: 12 }}>
                <div className="col-md-12" style={{ marginBottom: 10 }}>
                  <label style={{ color: "black", fontWeight: 600 }}>
                    Agendamentos em que o candidato será vinculado <b style={{color:'red'}}>*</b>
                  </label>
                  <InputGroup size="sm" className="mb-2">
                    <FormControl
                      placeholder="Pesquisar agendamento..."
                      value={processos_search}
                      onChange={this.handleProcessosSearchChange}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => this.goToProcessosPage(1)}
                    >
                      Buscar
                    </Button>
                  </InputGroup>
                  {loading_processos && (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <Spinner animation="border" size="sm" />
                      <span>Carregando agendamentos...</span>
                    </div>
                  )}
                  {seletivos_selecionados.length > 0 && (
                    <div style={{ marginBottom: 8, fontSize: 12, color: "#333" }}>
                      <b>Selecionados:</b>{" "}
                      {seletivos_selecionados
                        .map((id) => seletivos_detalhes.find((item) => String(item.id) === String(id))?.name || `#${id}`)
                        .join(", ")}
                    </div>
                  )}
                  <ListGroup style={{ maxHeight: 280, overflowY: "auto" }}>
                    {processos.map((p) => (
                      <ListGroup.Item
                        key={p.id}
                        action
                        active={seletivos_selecionados.includes(String(p.id))}
                        onClick={() => this.toggleSeletivo(p)}
                      >
                        <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                          <input
                            type="checkbox"
                            checked={seletivos_selecionados.includes(String(p.id))}
                            readOnly
                            style={{ marginTop: 4 }}
                          />
                          <div>
                            <div style={{ fontWeight: 600 }}>{p.name}</div>
                            <div style={{ fontSize: 12 }}>
                              <b>Início:</b> {this.formatProcessoDate(p.inicio)}{" "}
                              <b style={{ marginLeft: 8 }}>Encerramento:</b> {this.formatProcessoDate(p.fim)}
                            </div>
                          </div>
                        </div>
                      </ListGroup.Item>
                    ))}
                    {processos.length === 0 && !loading_processos && (
                      <ListGroup.Item disabled>
                        Nenhum agendamento encontrado
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                  {this.renderPagination(
                    processos_page,
                    processos_last_page,
                    this.goToProcessosPage,
                  )}
                </div>
              </div>
            )}

            <div className="row" style={{ marginTop: 12 }}>
              <div className="col-md-12">
                <label style={{ color: "black", fontWeight: 600 }}>
                  Observações (Obrigatório se inscrição for indeferida - Mínimo 10 caractéres)
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  value={avaliacao_observacoes}
                  onChange={(e) =>
                    this.setState({ avaliacao_observacoes: e.target.value })
                  }
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={this.closeModalAvaliacao}
              className="mr-2"
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={this.handleSaveAvaliacao}
              disabled={saving_avaliacao}
            >
              {saving_avaliacao ? "Salvando..." : "Salvar"}
            </Button>
          </Modal.Footer>
          {this.state.alert}
        </Modal>

        <ExamesAnterioresModal
          show={showExamesModal}
          onHide={() => this.setState({ showExamesModal: false })}
          onConfirm={this.submitAvaliacao}
          onReject={() => this.submitAvaliacao()}
          inscricao={this.state.inscricao}
          loading={this.state.saving_avaliacao}
        />
      </>
    );
  }
}

export default AvaliacaoModal;
